import { PackageTypeEnum } from '../domain';
import { z } from 'zod';

export const SourcesParamUniversal = z.object({
  type: z.nativeEnum(PackageTypeEnum),
  id: z.string(),
  sourceId: z.string(),
  revisionId: z.string(),
});
